import React, { Component } from 'react'
import { DEVICE_LOGGER_QUERY} from "../../queries/Queries"
import { useQuery } from '@apollo/react-hooks';
import CircularProgressIndicator from '../elements/CircularProgressIndicator';
import { AUTH_TOKEN } from '../../constants';
import DeviceLogger from './DeviceLogger';
import { FaSortDown, FaSortUp } from 'react-icons/fa';
import { flattenStrapiData } from '../../utils/utilities';

class DeviceLoggerList extends Component {
  state = {
    error: "",
    columns: [
    {column: "id", direction: "asc"},
    {column: "event_time", direction: "asc"},
    {column: "username", direction: "asc"}
    ],
    sortBy: "id:desc"
  }

  updateColumn(at) {
    let column = this.state.columns[at]

    column.direction = column.direction === 'asc' ? 'desc' : 'asc'
    let columns = this.state.columns
    columns[at] = column
    let sortBy =  column.column + ":" + column.direction
    this.setState({columns: columns,
      sortBy: sortBy})
  }

  render() {
    const token = localStorage.getItem(AUTH_TOKEN)
    if(!token) {
      return(
        <div>
          <span className="Error">You must be loged in first</span>
        </div>
      )
    }

    return (
      <div>
          <GetList
            token={token} 
            locked={this.state.locked}
            updateColumn={this.updateColumn.bind(this)}
            columns={this.state.columns}
            sortBy={this.state.sortBy}
          />
        <br/>
        <div><span className="error">{this.state.error}</span></div>
      </div>
    )
  }
}

function GetList({locked, token, updateColumn, columns, sortBy}) {
  const {data, loading, error, refetch} = useQuery(DEVICE_LOGGER_QUERY, {variables: {sortBy: sortBy}})
  
  if(loading) return(<CircularProgressIndicator size={60} />)
  if(error) return(<span className="error">{error.message}</span>)
  


  function sort(columnNumber) {
    updateColumn(columnNumber)
    refetch({variables: {sortBy: sortBy}})
  }

  function getArrow(direction) {
    return direction === "asc" ? <FaSortUp/> : <FaSortDown/>
  }
  let deviceLogs = data.deviceLogs.data
  return (
    <table className="table table-bordered">
      <thead>
        <tr>
          <th onClick={() => sort(0)}><div><h4>Id</h4>{getArrow(columns[0].direction)}</div></th>
          <th onClick={() => sort(1)}><div><h4>Event Time</h4>{getArrow(columns[1].direction)}</div></th>
          <th onClick={() => sort(2)}><div><h4>Username</h4>{getArrow(columns[2].direction)}</div></th>
          <th><h4>Device model</h4></th>
          <th><h4>Version</h4></th>
          <th><h4>Build number</h4></th>
          <th><h4>Error message</h4></th>
          <th><h4>User agent</h4></th>
          <th><h4>Screen resolution</h4></th>
          <th><h4>Todays logs</h4></th>
          <th><h4>Past visited classes</h4></th>
        </tr>
      </thead>
      <tbody>
        {deviceLogs.map(deviceLog => {
          deviceLog = flattenStrapiData(deviceLog)
          return <DeviceLogger 
          key={deviceLog.id} 
          deviceLog={deviceLog}/>
        })}
      </tbody>
    </table>
  )
}

export default DeviceLoggerList